import { Fragment, useEffect, useState } from "react";
import { useSession } from "../../state/SessionProvider";
import { hentUleste } from "../../state/session";
import { PRIVAT_ID } from "../../config/production";
import { heavy } from "../../components/haptics";

/**
 * Velg aktiv produksjon.
 *
 * En frilanser kan ha dagjobb paa én produksjon og kveldsjobb paa en annen.
 * Den valgte er den loggen, hurtigknappene, sidene og timeføringen gjelder
 * for — alt annet i appen vet bare om én.
 *
 * «Privat» staar nederst og kan ikke fjernes. Det er stedet loggen ligger
 * naar man jobber utenfor en produksjon, og feltappen skal kunne brukes av
 * hvem som helst uten at noen har invitert hen noe sted.
 */
export function ProduksjonPane(): JSX.Element {
  const {
    produksjoner, production, byttTilProduksjon, glemLokalProduksjon,
    timerAnnetSted,
  } = useSession();
  /* To trykk, som alt annet som ikke kan angres. */
  const [armert, setArmert] = useState<string | null>(null);
  useEffect(() => {
    if (armert === null) return;
    const ur = window.setTimeout(() => setArmert(null), 4000);
    return () => window.clearTimeout(ur);
  }, [armert]);

  /* Leses ÉN gang naar ruta aapnes. Kvitteringen skjer i byttet, og da
     lukkes menyen uansett. */
  const uleste = new Set(hentUleste().map((u) => u.produksjonId));

  return (
    <>
      <span className="mono" style={{ fontSize: 12, lineHeight: 1.6, color: "var(--ink-dim)" }}>
        Loggen, hurtigknappene og timeføringen følger produksjonen du står i.
        Privat er arbeid utenfor en produksjon.
      </span>

      <div className="menu__group">
        {produksjoner.map((p) => {
          const valgt = p.production.id === production.id;
          const privat = p.production.id === PRIVAT_ID;
          /*
           * Arbeidsdagen som gaar et annet sted vises paa produksjonen den
           * hoerer til. Uten dette ville den vaert umulig aa finne igjen:
           * timeren foelger ikke med i byttet, og timerflaten viser bare
           * den produksjonen appen staar i.
           */
          const harTimer = timerAnnetSted?.productionId === p.production.id;
          const utenTilgang = p.production.utenTilgang === true;
          return (
            <Fragment key={p.production.id}>
            <button
              type="button"
              className="menu__row"
              aria-current={valgt}
              onClick={() => {
                if (valgt) return;
                heavy();
                byttTilProduksjon(p.production.id);
              }}
            >
              <span style={{ color: valgt ? "var(--tc)" : undefined }}>
                {p.production.name}
                {/* Invitert, aldri vaert inne. Samme merke som paa raden
                    i hovedmenyen — der staar antallet, her staar det
                    HVILKEN det gjelder. */}
                {!uleste.has(p.production.id) ? null : (
                  <span className="menu__merke menu__merke--prikk" aria-label="ny" />
                )}
              </span>
              <span className="menu__rowvalue">
                {/* Uten tilgang: produksjonen er ikke din lenger, men
                    postene som aldri kom fram ligger her til
                    sluttdatoen. Se db.slettProduksjonLokalt. */}
                {p.production.utenTilgang === true ? "ingen tilgang · " : ""}
                {harTimer ? "dag går · " : ""}
                {privat || p.production.utenTilgang === true
                  ? "" : `${p.production.framerate} fps · `}
                {valgt ? "valgt" : ""}
              </span>
            </button>
            {/* VEIEN UT.
                En produksjon man ikke er med i lenger blir staaende saa
                lenge noe uleverte ligger her. Da maa det finnes en maate
                aa si at det ikke skal leveres paa — ellers ligger den til
                sluttdatoen uansett hva brukeren mener. */}
            {!utenTilgang ? null : (
              <button
                type="button"
                className="menu__row"
                onClick={() => {
                  if (armert !== p.production.id) {
                    setArmert(p.production.id);
                    return;
                  }
                  setArmert(null);
                  glemLokalProduksjon(p.production.id);
                }}
              >
                <span style={{ color: "var(--state-bad)", fontSize: 13 }}>
                  {armert === p.production.id
                    ? "Slett alt som ligger her?"
                    : "Fjern fra telefonen"}
                </span>
                <span className="menu__rowvalue">
                  {armert === p.production.id ? "kan ikke angres" : ""}
                </span>
              </button>
            )}
            </Fragment>
          );
        })}
      </div>
    </>
  );
}
